tinymce.Resource.add('tinymce.html-i18n.help-keynav.sk',
'<h1>Začíname s navigáciou pomocou klávesnice</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Prejsť na panel s ponukami</dt>\n' +
  '  <dd>Windows alebo Linux: Alt+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  '  <dt>Prejsť na panel nástrojov</dt>\n' +
  '  <dd>Windows alebo Linux: Alt+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Prejsť na pätičku</dt>\n' +
  '  <dd>Windows alebo Linux: Alt+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Zaostriť na oznámenie</dt>\n' +
  '  <dd>Windows alebo Linux: Alt+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  '  <dt>Prejsť na kontextový panel nástrojov</dt>\n' +
  '  <dd>Windows, Linux alebo macOS: Ctrl+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  '<p>Navigácia začne pri prvej položke používateľského rozhrania, ktorá bude zvýraznená alebo v prípade prvej položky\n' +
  '  cesty k pätičke podčiarknutá.</p>\n' +
  '\n' +
  '<h1>Navigácia medzi časťami používateľského rozhrania</h1>\n' +
  '\n' +
  '<p>Ak sa chcete posunúť z jednej časti používateľského rozhrania do druhej, stlačte tlačidlo <strong>Tab</strong>.</p>\n' +
  '\n' +
  '<p>Ak sa chcete posunúť z jednej časti používateľského rozhrania do predchádzajúcej, stlačte tlačidlá <strong>Shift + Tab</strong>.</p>\n' +
  '\n' +
  '<p>Poradie prepínania medzi týmito časťami používateľského rozhrania pri stláčaní tlačidla <strong>Tab</strong>:</p>\n' +
  '\n' +
  '<ol>\n' +
  '  <li>Panel s ponukou</li>\n' +
  '  <li>Každá skupina panela nástrojov</li>\n' +
  '  <li>Bočný panel</li>\n' +
  '  <li>Cesta k prvku v pätičke</li>\n' +
  '  <li>Prepínač počtu slov v pätičke</li>\n' +
  '  <li>Odkaz na informácie o značke v pätičke</li>\n' +
  '  <li>Úchyt na zmenu veľkosti editora v pätičke</li>\n' +
  '</ol>\n' +
  '\n' +
  '<p>Ak nejaká časť používateľského rozhrania nie je prítomná, preskočí sa.</p>\n' +
  '\n' +
  '<p>Ak je pätička vybratá na navigáciu pomocou klávesnice a nie je viditeľný bočný panel, stlačením klávesov <strong>Shift+Tab</strong>\n' +
  '  prejdete na prvú skupinu panela nástrojov, nie na poslednú.</p>\n' +
  '\n' +
  '<h1>Navigácia v rámci častí používateľského rozhrania</h1>\n' +
  '\n' +
  '<p>Ak sa chcete posunúť z jedného prvku používateľského rozhrania na ďalší, stlačte príslušný kláves so <strong>šípkou</strong>.</p>\n' +
  '\n' +
  '<p>Klávesy so šípkami <strong>doľava</strong> a <strong>doprava</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>umožňujú presun medzi ponukami na paneli ponúk,</li>\n' +
  '  <li>otvárajú podponuku v rámci ponuky,</li>\n' +
  '  <li>umožňujú presun medzi tlačidlami v skupine panelov nástrojov,</li>\n' +
  '  <li>umožňujú presun medzi položkami cesty prvku v pätičke.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Klávesy so šípkami <strong>dole</strong> a <strong>hore</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>umožňujú presun medzi položkami ponuky,</li>\n' +
  '  <li>umožňujú presun medzi položkami v kontextovej ponuke panela nástrojov.</li>\n' +
  '</ul>\n' +
  '\n' +
  '<p>Klávesy so <strong>šípkami</strong> vykonávajú prepínanie v rámci vybranej časti používateľského rozhrania.</p>\n' +
  '\n' +
  '<p>Ak chcete zatvoriť otvorenú ponuku, otvorenú podponuku alebo otvorenú kontextovú ponuku, stlačte kláves <strong>Esc</strong>.</p>\n' +
  '\n' +
  '<p>Ak je aktuálne vybratá horná časť konkrétneho používateľského rozhrania, stlačením klávesu <strong>Esc</strong> úplne ukončíte tiež\n' +
  '  navigáciu pomocou klávesnice.</p>\n' +
  '\n' +
  '<h1>Vykonanie príkazu položky ponuky alebo tlačidla panela nástrojov</h1>\n' +
  '\n' +
  '<p>Keď je zvýraznená požadovaná položka ponuky alebo tlačidlo panela nástrojov, stlačením klávesov <strong>Return</strong>, <strong>Enter</strong>\n' +
  '  alebo <strong>medzerníka</strong> vykonáte príslušný príkaz položky.</p>\n' +
  '\n' +
  '<h1>Navigácia v dialógových oknách bez záložiek</h1>\n' +
  '\n' +
  '<p>Pri otvorení dialógových okien bez záložiek prejdete na prvý interaktívny komponent.</p>\n' +
  '\n' +
  '<p>Medzi interaktívnymi dialógovými komponentmi môžete prechádzať stlačením klávesov <strong>Tab</strong> alebo <strong>Shift+Tab</strong>.</p>\n' +
  '\n' +
  '<h1>Navigácia v dialógových oknách so záložkami</h1>\n' +
  '\n' +
  '<p>Pri otvorení dialógových okien so záložkami prejdete na prvé tlačidlo v ponuke záložiek.</p>\n' +
  '\n' +
  '<p>Medzi interaktívnymi komponentmi tejto dialógovej záložky môžete prechádzať stlačením klávesov <strong>Tab</strong> alebo\n' +
  '  <strong>Shift+Tab</strong>.</p>\n' +
  '\n' +
  '<p>Ak chcete prepnúť na ďalšiu záložku dialógového okna, prejdite do ponuky záložiek a potom môžete stlačením príslušného klávesu so <strong>šípkou</strong>\n' +
  '  prepínať medzi dostupnými záložkami.</p>\n');